"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Pagination_1 = __importDefault(require("react-bootstrap/Pagination"));
var PaginationUtil_1 = require("./PaginationUtil");
var AcPageNumber_1 = require("./AcPageNumber");
var AcButton_1 = require("./../button/AcButton");
exports.AcPagination = function (props) {
    var page = props.page, size = props.size, totalElements = props.totalElements, onClickPage = props.onClickPage, totalVisible = props.totalVisible;
    if (page === undefined || page < 0 || !size || !totalElements)
        return react_1.default.createElement(react_1.default.Fragment, null);
    var currentPage = page;
    var totalPages = Math.ceil(totalElements / size);
    var items = PaginationUtil_1.pageItems(currentPage, totalPages, totalVisible, 0);
    var pageNumbers = items.map(function (i, index) {
        if (i === -1) {
            return (react_1.default.createElement("div", { className: "page-ellipsis", key: index },
                react_1.default.createElement(Pagination_1.default.Ellipsis, null)));
        }
        else {
            return (react_1.default.createElement(AcPageNumber_1.AcPageNumber, { key: index, active: currentPage === i, page: i, onClickPage: onClickPage }));
        }
    });
    var handlePageNav = function (newPage) {
        if (onClickPage != null)
            onClickPage(newPage);
    };
    return (react_1.default.createElement("div", { className: "d-flex justify-content-center" },
        react_1.default.createElement("div", { className: "page-prev-next" },
            react_1.default.createElement(AcButton_1.AcButton, { variant: "apzlightblue", className: "px-0 page-link", disabled: currentPage === 1, onClick: function () { return handlePageNav(currentPage - 1); } },
                react_1.default.createElement("i", { className: "fas fa-chevron-left fa-fw text-body fs-12" }))),
        react_1.default.createElement(Pagination_1.default, { className: "m-0" }, pageNumbers),
        react_1.default.createElement("div", { className: "page-prev-next" },
            react_1.default.createElement(AcButton_1.AcButton, { variant: "apzlightblue", className: "px-0 page-link", disabled: currentPage === items[items.length - 1], onClick: function () { return handlePageNav(currentPage + 1); } },
                react_1.default.createElement("i", { className: "fas fa-chevron-right fa-fw text-body fs-12" })))));
};
exports.AcPagination.defaultProps = {
    totalVisible: 8,
};
exports.AcPagination.displayName = 'AcPagination';
//# sourceMappingURL=AcPagination.js.map